import { PropsWithChildren, useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'

import { useGetUser } from '@/feature/auth'
import { useFlags } from '@/feature/feature-flags'

export const AnalyticsDataProvider = ({ children }: PropsWithChildren) => {
  const { data: userData } = useGetUser()
  const flags = useFlags()

  useEffect(() => {
    if (userData) {
      Sentry.setUser({
        email: userData.email,
        id: userData.id,
        username: userData.firstName,
      })

      Sentry.setContext('organisation', {
        name: userData.organization?.name,
        id: userData.organization?.id,
      })
    } else {
      Sentry.setUser(null)
      Sentry.getCurrentScope().clear()
    }
  }, [userData])

  useEffect(() => {
    if (flags) {
      Sentry.setContext('feature-flags', flags)
    }
  }, [flags])
  return children
}
